<script>
import ProcessesController from "../../../Mixins/ProcessesController";
import Breadcrumbs from "../../../Comps/General/Breadcrumbs.vue";
import HeaderName from "../../../Comps/General/HeaderName.vue";
import Permissions from "../../../Mixins/Permissions";

export default {
    name: "Show",
    components: { HeaderName, Breadcrumbs },

    mixins: [ProcessesController, Permissions],

    data() {
        return {
            bread: [
                {
                    text: "Accident reports",
                    disabled: false,
                    link: this.route("accident-reports.index"),
                },
                {
                    text: `Accident report - ${this.$page.props.accidentReport.job_reference}`,
                    disabled: true,
                },
            ],
        };
    },

    computed: {
        report() {
            return this.$page.props.accidentReport;
        },
    },
};
</script>

<template>
    <v-container class="fixed">
        <breadcrumbs :items="bread"></breadcrumbs>
        <div class="d-flex align-center">
            <header-name
                >Accident report - {{ this.report.job_reference }}
            </header-name>
            <inertia-link
                v-if="
                    isSuperAdmin ||
                    report.creator_id === $page.props.auth.user.id
                "
                class="ml-auto"
                :href="route('accident-reports.edit', report)"
            >
                <v-btn color="primary" small> Edit</v-btn>
            </inertia-link>
        </div>

        <div class="mt-8">
            <div class="flex flex-wrap">
                <div class="w-full">
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Date of accident</div>
                        <div>
                            {{ momentFormatDateYear(report.accident_date) }}
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Reported by</div>
                        <div>
                            {{ report.creator.name }}
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Affectee Name</div>
                        <div>
                            {{ report.affectee_name }}
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Affectee Address</div>
                        <div>
                            {{ report.affectee_address }}
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Affectee Occupdation</div>
                        <div>
                            {{ report.affectee_occupation }}
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Location</div>
                        <div class="text-pre-line">
                            <span>{{ report.accident_location }}</span>
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Description</div>
                        <div class="text-pre-line">
                            <span>{{ report.accident_description }}</span>
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Injury</div>
                        <div class="text-pre-line">
                            <span>{{ report.injury_description }}</span>
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Cause</div>
                        <div class="text-pre-line">
                            <span>{{ report.accident_cause }}</span>
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Prevention</div>
                        <div class="text-pre-line">
                            <span>{{ report.accident_prevention }}</span>
                        </div>
                    </div>
                    <div class="text-body-1 mb-4">
                        <div class="font-weight-bold">Action taken</div>
                        <div class="text-pre-line">
                            <span>{{ report.accident_action }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<style scoped></style>
